import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { Order } from 'src/app/models/models';
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-order-repeat',
  templateUrl: './order-repeat.component.html',
  styleUrls: ['./order-repeat.component.scss'],
  standalone: false
})
export class OrderRepeatComponent implements OnInit {

  order: Order;
  order_number: number;
  order_id: number;
  cartRef: string;
  urlOrder: string;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
  ) {
    this.order = this.navParams.data.info.order;
    this.order_number = this.navParams.data.info.order.number;
    this.order_id = this.navParams.data.info.order.id;
    this.cartRef = `/cart?orderId=${this.order_id}`;
    this.urlOrder = environment.url[0] + '//' + environment.url[2] + this.cartRef;
  }

  ngOnInit() {
  }

  onCloseModal() {
    this.modalCtrl.dismiss();
  }

  onRepeatOrder() {
    window.open(this.urlOrder, '_self');
    this.modalCtrl.dismiss();
  }

}
